import { Configuration, ApiApi } from "./generated";

const config = new Configuration({
  basePath: process.env.LIVESCORE_BACKEND_URL,
});

export const livescoreClient = new ApiApi(config);
